/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */
$('.slider-text').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    dots: true,
    prevArrow:"<i class='fa fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fa fa-angle-right slick-next'></i>",

    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,

      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,

      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        dots: false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object 
  ]

});

